import React, { useEffect, useState } from "react";

import {
  SUPERVISOR_BULK_URL,
  SUPERVISOR_BULK_RESULT_URL,
} from "configs/constants";
import Form from "components/Form";
import Table from "@Components/Table";
import * as Yup from "yup";
import eightAxios from "configs/axiosConfig";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import Alert from "@material-ui/lab/Alert";
import { Paper } from "@material-ui/core";
import { useTranslation } from "react-i18next";

import axios from "axios";
// import { isObjectEmpty } from "utils";
// import Error from "views/Error/Error";

let model = [
  { id: "SN", label: "SN", type: "string" },
  { id: "worker_code", label: "Worker ID", type: "string" },
  { id: "worker_name", label: "Worker", type: "string" },
  { id: "supervisor_code", label: "Supervisor ID", type: "string" },
  { id: "supervisor_name", label: "Supervisor Name", type: "string" },
  { id: "worker_group_code", label: "Worker Group ID", type: "string" },
  { id: "worker_group_name", label: "Worker Group Name", type: "string" },
  { id: "status", label: "Status", type: "string" },
  { id: "remarks", label: "Remarks", type: "string" },
];

const initialValues = {};

const SUPPORTING_DOCUMENT_FORMATS = [
  ".csv",
  "text/csv",
  "application/vnd.ms-excel",
];

const detailURL = "/configuration/get-config/";
const templateURL = "download-template/?type=supervisor";
const FileDownload = require("js-file-download");

const SupervisorBulkAssignment = () => {
  const { t } = useTranslation();

  const [displayTable, setDisplayTable] = useState(false);
  const [buttonCounter, setButtonCounter] = useState(0);
  const [fileSize, setFileSize] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object({
    file: Yup.mixed()
      .test("fileSize", "File is too large", (value) => {
        if (value === null) {
          return false;
        } else if (typeof value === "string") {
          return true;
        } else {
          return value.size <= fileSize;
        }
      })
      .test("fileType", "Unsupported file type", (value) => {
        if (value === null) {
          return false;
        } else if (typeof value === "string") {
          return true;
        } else {
          return SUPPORTING_DOCUMENT_FORMATS.includes(value.type);
        }
      }),
  });

  const fetchDetails = () => {
    setLoading(true);
    eightAxios
      .get(detailURL)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.max_file_upload_size) {
            setFileSize(response.data.max_file_upload_size * 1024 * 1024);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
        setLoading(false);
      });
  };

  const fetchTemplate = () => {
    setLoading(true);
    const API_VERSION = "v1";
    const API_URL = process.env.REACT_APP_API_URL;
    let baseURL = `${API_URL}${API_VERSION}/`;
    const headers = {
      Authorization: `JWT ${localStorage.getItem("token")}`,
    };
    axios({
      url: baseURL + templateURL,
      method: "get",
      headers: headers,
      responseType: "blob",
    })
      .then(function (response) {
        FileDownload(response.data, "Supervisor_upload_template.csv");
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  const formFields = [
    {
      type: "fileupload",
      name: "file",
      accept: ".csv",
      label: "Supervisor Assignment File",
      supportedTypes: [t("csv file only")],
      buttonText: "Browse",
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Submit",
      color: "primary",
    },
  ];

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  return (
    <div>
      <Paper style={{ padding: "10px" }}>
        <Form
          initialValues={initialValues}
          submitUrl={SUPERVISOR_BULK_URL}
          formFields={formFields}
          formButtons={formButtons}
          afterSubmit={() => {
            setDisplayTable(true);
            setButtonCounter(buttonCounter + 1);
          }}
          isMultipart
          formTitle="Bulk Supervisor Assignment"
          validationSchema={validationSchema}
          noTypography={true}
          downloadTemplate={fetchTemplate}
        />
        {tableData && tableData.extra ? (
          <Alert
            severity={tableData.extra.failed > 0 ? "error" : "success"}
            style={{ marginTop: "10px", marginBottom: "10px" }}
          >
            {`Total: ${
              tableData.extra.success + tableData.extra.failed
            }, Successful: ${tableData.extra.success}, Failed: ${
              tableData.extra.failed
            }`}
          </Alert>
        ) : null}
      </Paper>
      {displayTable ? (
        <Table
          model={model}
          noFilter
          proxyURL={SUPERVISOR_BULK_RESULT_URL}
          excelExport={{ fileName: "BulkSupervisorAssignmentResult" }}
          polling
          outerFetchTrigger={buttonCounter}
          noAddButton
          setTableData={setTableData}
        />
      ) : null}
    </div>
  );
};

export default SupervisorBulkAssignment;
